import React, {
    useCallback,
    useContext,
    useState
} from "react";
import axios from "axios";
import {
    Alert,
    Button,
    Modal,
    Spinner
} from "react-bootstrap";
import PropTypes from "prop-types";

import ShopsContext from "../../../../context/ShopsContext";

function DeleteSegmentBlockModal({ show, handleClose, product, block, onDeleted }) {
    const shopsContext = useContext(ShopsContext);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const reset = useCallback(() => {
        setLoading(false);
        setError(null);
    }, []);

    const handleDelete = useCallback(async () => {
        if(!block) return;
        setLoading(true);
        setError(null);
        try {
            const response = await axios.post("/deleteRentalProductSegmentBlock", {
                shopId: shopsContext.currentShop.id,
                productId: product.id,
                blockId: block.id,
            });
            if(response.data.valid) {
                handleClose();
                onDeleted?.();
            } else {
                setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
            }
        } catch(requestError) {
            console.error(requestError);
            setError("Er ging iets fout. Probeer het later opnieuw.");
        }
        setLoading(false);
    }, [shopsContext.currentShop.id, product, block, handleClose, onDeleted]);

    return (
        <Modal show={ show } onHide={ handleClose } onShow={ reset }>
            <Modal.Header closeButton>
                <Modal.Title>Blokkering verwijderen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { error && (
                    <Alert variant="danger">{ error }</Alert>
                )}
                <p className="mb-0">
                    Weet je zeker dat je deze blokkering wilt verwijderen?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={ handleClose } disabled={ loading }>
                    Annuleren
                </Button>
                <Button variant="danger" onClick={ handleDelete } disabled={ loading }>
                    { loading && (
                        <Spinner animation="border" variant="light" size="sm" className="mr-2"/>
                    )}
                    Verwijderen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
DeleteSegmentBlockModal.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    block: PropTypes.object,
    onDeleted: PropTypes.func,
}

export default React.memo(DeleteSegmentBlockModal);
